import {API_Record, API_Service} from "../../utils/network/API";
import {CommonService} from "../../common/commonService";

export const VaccinationItemType = {
	header: 0,
	content: 1
}

export default class VaccinationService {
	constructor() {
		this.commonService = new CommonService(API_Service.ezHealth);
	}

	getVaccinationList(param, success, fail) {
		this.commonService.fetchData(API_Record.showVaccineHisByAccountIDByPage, param, (data) => {
			const list = this.filterList(data)
			success && success(list)
		}, fail)
	}

	filterList(response) {
		let groupMap = new Map()
		for(let i = 0;i < response.length; i ++) {
			groupMap.set(response[i].GroupCode, {'groupCode': response[i].GroupCode, 'groupName': response[i].GroupName, 'nextDue': response[i].NDate})
		}
		let sections = []
		let otherCategory = null
		let j = 0
		for (let groupInfo of groupMap) {
			let list = []
			for(let i = 0 ;i < response.length; i ++) {
				if (response[i].GroupCode === groupInfo[0]) {
					list.push(Object.assign({key: i}, response[i]))
				}
			}

			const sortList = list.sort((x, y) => {
				let xYear = x.ADate.substr(6,4)
				let xMonth = x.ADate.substr(0,2)
				let xDay = x.ADate.substr(3, 2)

				let yYear = y.ADate.substr(6,4)
				let yMonth = y.ADate.substr(0,2)
				let yDay = y.ADate.substr(3, 2)

				let xDate = xYear + xMonth + xDay
				let yDate = yYear + yMonth + yDay

				if ((xDate < yDate)) {
					return 1
				}
				else return -1
			});

			sortList.forEach((item, index) => {
				item.key = index
			})

			sections.push({key: j,'groupName' : groupInfo[1].groupName, 'groundCode': groupInfo[1].groupCode, 'nextDue': groupInfo[1].nextDue, data: sortList})
			if (groupInfo[1].groupCode === 'VG00') {
				otherCategory = {key: j,'groupName' : groupInfo[1].groupName, 'groundCode': groupInfo[1].groupCode, 'nextDue': groupInfo[1].nextDue, data: sortList}
			}
			j = j + 1
		}

		const sectionsWithCategory = sections.filter((value) => value.groundCode !== 'VG00')

		const sortSectionsWithCategory = sectionsWithCategory.sort((x, y) => {
			if ((x.groupName > y.groupName)) {
				return 1
			}
			else return -1
		})

		let dataSource = []
		dataSource = dataSource.concat(sortSectionsWithCategory)

		if (otherCategory !== null) {
			dataSource.push(otherCategory)
		}

		let list = []
		for (let i = 0 ; i < dataSource.length; i ++) {
			let section = dataSource[i]
			let item = {type: VaccinationItemType.header, name: section.groupName, due: section.nextDue}
			list.push(item)

			let mergeList = section.data.map((item) => {
				return Object.assign({type: VaccinationItemType.content}, item)
			})

			list = list.concat(mergeList)

		}

		return list
	}
}
